import { Card } from '@mui/material';
import './styles.scss';
export const CheckoutLoadingSkeleton = () => {
	return (
		<div className="container checkout-loading-screen p-10 w-100 h-100">
			<Card
				className="h-100 rounded-lg p-15 d-flex flex-column align-items-start"
				style={{ gap: 24 }}
			>
				<div className="skeleton-box w-100"></div>
				<div className="skeleton-box w-100"></div>
				<div className="d-flex w-100" style={{ gap: 24 }}>
					<div className="skeleton-box" style={{ flex: 1 }}></div>
					<div className="skeleton-box" style={{ flex: 1 }}></div>
				</div>
				<div className="skeleton-box w-100"></div>

				<div
					className="skeleton-box w-25 mt-6"
					style={{ height: 32 }}
				></div>
				<div className="skeleton-box w-100"></div>
				<div className="d-flex w-100" style={{ gap: 24 }}>
					<div className="skeleton-box" style={{ flex: 1.5 }}></div>
					<div className="skeleton-box" style={{ flex: 1 }}></div>
				</div>
				<div className="skeleton-box w-100"></div>

				<div
					className="skeleton-box w-25 mt-6"
					style={{ height: 32 }}
				></div>
				<div className="d-flex w-100" style={{ gap: 24 }}>
					<div className="skeleton-box" style={{ flex: 1 }}></div>
					<div className="skeleton-box" style={{ flex: 1.5 }}></div>
				</div>
			</Card>
		</div>
	);
};
